<template>
<div class="subManSliderBar">
  <VuePerfectScrollbar
    class="scroll-area--customizer"
    :settings="settings"
    :key="$vs.rtl"
  >
    <div class="content">
      <div
        class="bar-item"
        v-for="(item,index) in listData"
        :key="index"
        :class="{
          on: currentIndex  == index
        }"
        @click="barItemHandle(index)"
      >
        <div class="item-top">
          <span class="issue">{{item.masterAlias}}</span>
          <span
            :style="getStyle(item.status)"
            class="status tag-box">{{getStaus(item.status)}}</span>
        </div>
        <div class="times">
          {{parseTime(item.beginDate)}}
        </div>
      </div>
    </div>
  </VuePerfectScrollbar>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import initData2 from '@/mixins/initData';
import {getStaus, getStyle} from "@/components/user/details/mamSub/ICopy/utils";
import { parseTime,colorRgba,} from "@/utils";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "subManSliderBar",
  components: {
    VuePerfectScrollbar,
  },
  props: {
  },
  data() {
    return {


      currentIndex: 0,//默认是选中第一个

      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      statistics: {
        totalProfit: 0,
      },
    }
  },
  mixins: [initData2],
  watch:{
    listRefresh(val){
      this.getData();
    }
  },
  computed:{
    ...mapGetters(['listRefresh']),
  },
  mounted() {
    this.$nextTick(() => {
      this.getData();
    })
  },
  methods: {
    parseTime,
    getStyle,
    getStaus,
    getData(){
      this.init().then((res) => {
        this.$emit('current-cycle',this.listData[this.currentIndex]);
        let hasOne = this.listData.some((item) => {
          return item.status === 0; // 0有效订阅
        });
        if(hasOne){
          this.$emit('no-one-active',true);
        }else {
          this.$emit('no-one-active',false);
        }
      });
    },
    beforeInit(){
      this.params = {
        mtId: +this.$route.params.mtid,
      }
      if(this.sort){
        this.params.sort = this.sort;
      }
      this.url = '/crm/reception/queryCopySubscription';
      return true;
    },
    barItemHandle(index){
      this.currentIndex = index;
      this.$emit('current-cycle',this.listData[this.currentIndex]);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/scss/variable";
.subManSliderBar {
  //需要区分pc端和移动端  todo
  //高度滑动有点问题  todo
  .bar-item {
    height: 68px;
    padding: 12px 20px;
    border-bottom: 1px solid #F4F4F4;
    cursor: pointer;
    .item-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .issue {
        color: #5E5873;
      }
      .tag-box {
        display: inline-block;
        padding-left: 15px;
        padding-right: 15px;
      }
    }
    .times {
      color: #A29FAE;
    }
    &.on {
      border-left: 4px solid $themeColor;
      .issue {
        color: $themeColor;
      }
    }
  }
}
</style>
